export default function Grain() {
  return <div className="vs-grain" aria-hidden />;
}
